export enum FootTrafficTimeCode {
  T6_10 = 'T6_10',
  T11_14 = 'T11_14',
  T15_17 = 'T15_17',
  T18_20 = 'T18_20',
  T21_00 = 'T21_00',
}

export enum FootTrafficAgeGroup {
  AG10 = 'AG10',
  AG20 = 'AG20',
  AG30 = 'AG30',
  AG40 = 'AG40',
  AG50 = 'AG50',
  AG60 = 'AG60',
}

export enum FootTrafficGender {
  m = 'Male',
  w = 'Female',
}

export enum FootTrafficWeekAgeTimeDayType {
  W = 'WeekDay',
  H = 'WeekEnd',
}

export enum FootTrafficVarTypes {
  gender = 'gender',
  age = 'ageGroup',
  time = 'timeCode',
  day = 'dayType',
}
